// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { mainNavigationStyles } from "@rpsc/Overrides/Widgets/Header/MainNavigation";
import ArrowDown from "@rpsc/XDL/Icons/IconAngleDown";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${color("common.background")};
        display: flex;
        gap: 50px;
        padding: 0;
        ${xScreen("lte", 1200)} {
            gap: 24px;
        }
    `,
};

mainNavigationStyles.menuItemTypography = {
    color: "common.black",
    size: 16,
    weight: fontConfig.weight.bold,
    css: css`
        line-height: 22px;
        display: flex;
        align-items: center;
        gap: 8px;
        &&:hover {
            color: ${color("common.ui8")};
        }
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        display: flex;
        align-items: center;
        padding: 0;
        ${IconWrapper} {
            color: ${color("text.link")};
            margin: 0;
        }

        & + .mega-menu {
            transform: translateY(11px);
        }
    `,
};

mainNavigationStyles.itemWrapper = {};

mainNavigationStyles.menuItemIcon = {
    src: ArrowDown,
    size: 13,
    css: css`
        width: 11px;
        margin-top: 2px !important;
    `,
};
